export default __webpack_public_path__ + "static/media/chronos-normal.356359bc.png";